import React from 'react'
import { ClientHomeUpdates } from '../Client/ClientHomeUpdates'
import { ModuleRedirectCards } from '../Client/ModuleRedirectCards'

export const VerificationHomePage = () => {
    return (
        <>
        <ClientHomeUpdates />
        <ModuleRedirectCards />
        </>
    )
}
